import { KeyValue } from "../../responses";

/**
 * Argument ConfPropertyValue. We have a ConfPropertyValue entity as well but that can't be used as a request model..
 */
export class ConfPropertyValueArgument {
  propertyName: string;
  keyAndValue?: KeyValue<string, string>;
  configurationId?: number;
}